<template>
    <div>
        <!--[if lt IE 7]>
        <p class="alert alert-danger">You are using an <strong>outdated</strong> browser. Please <a
            href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
        <![endif]-->

        <slot/>

    </div>
</template>

<script>

    export default {
        components: {
        },
        methods: {},
        mounted: function () {
            document.body.className = document.body.className.replace(" header_pasarela","");
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layouts/AnonLayout.vue